/* Copyright (c) Trimble Inc. All rights reserved. */

import { ENVIRONMENTS } from './config/env.config';
import { EnvironmentEndpoints, type Environment } from './models/AuthConfig.model';

/**
 * Get base URL for the given environment
 */
export const getBaseUrl = (environment: Environment): string => {
  return ENVIRONMENTS[environment].ISSUER;
};

/**
 * Get all endpoints for the given environment
 */
export const getEnvironmentEndpoints = (environment: Environment): EnvironmentEndpoints => {
  if (environment === 'LOCAL') return ENVIRONMENTS.LOCAL;
  // Return STAGING as fallback for unknown, null, or undefined environments (dev, qa, stage, etc.)
  return ENVIRONMENTS[environment] || ENVIRONMENTS.STAGING;
};
